// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.h-md-100[data-v-669a330e] {
  height: 100%;
}
.close-icon[data-v-669a330e] {
  color: #d3d3d3;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.text-permissions-overlay[data-v-669a330e] {
  position: fixed;
  z-index: 1034;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
}
.text-permissions-modal[data-v-669a330e] {
  position: fixed;
  z-index: 1035;
  left: 23vw;
  top: 5vh;
  width: 54vw;
  max-height: 92vh;
  overflow: auto;
}
.text-permissions-info[data-v-669a330e] {
  flex-basis: 42%;
}
.info-container[data-v-669a330e] {
  padding: 0 20%;
}
.text-permissions-form[data-v-669a330e] {
  flex-basis: 58%;
  background-color: #f5f5f5;
}
.form-container[data-v-669a330e] {
  padding-bottom: 36px;

  margin: 56px 68px 74px 68px;
  background-color: white;
}
.form-header[data-v-669a330e] {
  text-align: center;
}
.radio-btn[data-v-669a330e] {
  gap: 12px;
}
.radio-btn .custom-radio-btn-input[data-v-669a330e] {
  width: 20px;
  height: 20px;
  display: block;
}
.custom-radio-btn-input[data-v-669a330e] {
  position: relative;
  appearance: none;
  cursor: pointer;
}
.custom-radio-btn-input[data-v-669a330e]::before {
  content: "";
  width: 20px;
  height: 20px;
  background-color: black;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.3;
}
.custom-radio-btn-input[data-v-669a330e]::after {
  content: "";
  width: 18px;
  height: 18px;
  background-color: white;
  border: 4px solid white;
  border-radius: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  z-index: 2;
}
.custom-radio-btn-input[data-v-669a330e]:checked::after {
  background-color: black;
}
.radio-btn label[data-v-669a330e] {
  margin-bottom: 0px;
  cursor: pointer;
}
.user-name[data-v-669a330e] {
  font-size: 36px;
  margin-bottom: 8px;
}
.header-text[data-v-669a330e] {
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 30px;
}
.form-info[data-v-669a330e] {
  margin-bottom: 32px;
}
.question[data-v-669a330e] {
  margin-bottom: 72px;
  gap: 16px;
}
.number-required[data-v-669a330e] {
  color: red;
}
.number-container[data-v-669a330e] {
  margin-bottom: 76px;
}
.number-input[data-v-669a330e] {
  outline: none;
  border: unset;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 16px;
}
.number-input-error[data-v-669a330e] {
  color: red;
  font-size: 14px;
  margin-top: 8px;
}
.text-remainder-types[data-v-669a330e] {
  list-style: none;
  padding: unset;
  margin: unset;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.remainder-item[data-v-669a330e] {
  display: flex;
  gap: 16px;
  align-items: center;
}
.info-text[data-v-669a330e] {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 32px;
  margin-top: 16px;
}
.icon-container[data-v-669a330e] {
  width: 36px;
  height: 36px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-content[data-v-669a330e] {
  padding: 48px 40px 0px 46px;
}
.form-footer[data-v-669a330e] {
  margin-top: auto;
  gap: 16px;
  padding-top: 32px;
  border-top: 1px solid #e4e4e4;
}
.submit-button[data-v-669a330e] {
  border-radius: 24px;
  padding: 8px 32px;
  font-weight: bold;
}
.skip-button[data-v-669a330e] {
  background: unset;
  color: #d3d3d3;
  border-radius: 20px;
}
@media (max-width: 767px) {
.text-permissions-modal[data-v-669a330e] {
    height: 90vh;
    top: 2vh;
    width: 90vw;
    left: 5vw;
}
.info-container .primaryicon-longarrow-right[data-v-669a330e] {
    display: none;
}
.recall-notifications[data-v-669a330e] {
    order: 1;
}
.service-updates[data-v-669a330e] {
    order: 2;
}
.loan-updates[data-v-669a330e] {
    order: 3;
}
.text-permissions-modal-content[data-v-669a330e] {
    flex-direction: column-reverse;
}
.form-container[data-v-669a330e] {
    margin: unset;
}
.form-footer[data-v-669a330e] {
    padding: unset;
    border: unset;
}
.text-permissions-info[data-v-669a330e] {
    padding: unset;
    padding-bottom: 36px;
}
.info-container[data-v-669a330e] {
    padding: unset;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.info-text[data-v-669a330e] {
    font-size: 17px;
    line-height: 32px;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 24px;
}
.remainder-item span[data-v-669a330e] {
    font-size: 16px;
}
.question[data-v-669a330e] {
    margin-bottom: 24px;
}
.user-name[data-v-669a330e] {
    font-size: 32px;
}
.form-content[data-v-669a330e] {
    padding-top: 32px;
}
.header-text[data-v-669a330e] {
    margin-bottom: 17px;
    font-size: 18px;
    line-height: 26px;
}
.close-icon[data-v-669a330e] {
    top: 8px;
    right: 12px;
}
.number-container[data-v-669a330e] {
    margin-bottom: 32px;
}
}
@media (min-width: 768px) and (max-width: 1199px) {
.text-permissions-modal[data-v-669a330e] {
    width: 84vw;
    left: 8vw;
}
.info-container[data-v-669a330e] {
    padding: 0 10%;
}
.form-container[data-v-669a330e] {
    margin: 56px 40px 74px 40px;
}
}
@media (min-width: 1200px) and (max-width: 1399px) {
.text-permissions-modal[data-v-669a330e] {
    max-height: 90vh;
    width: 54vw;
    left: 23vw;
    top: 2vh;
}
}
@media (min-width: 1400px) {
.text-permissions-modal[data-v-669a330e] {
    max-height: 82vh;
    top: 5vh;
    width: 54vw;
    left: 23vw;
}
}
.error[data-v-669a330e] {
  border-bottom: 1px solid red !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TextPermissionsOverlay/TextPermissionsOverlay.vue"],"names":[],"mappings":";AAwHA;EACE,YAAY;AACd;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;AAEA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,oBAAoB;;EAEpB,2BAA2B;EAC3B,uBAAuB;AACzB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,SAAS;AACX;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;AAEA;EACE,UAAU;AACZ;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,oBAAoB;AACtB;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AAEA;AACE;IACE,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,SAAS;AACX;AAEA;IACE,aAAa;AACf;AAEA;IACE,QAAQ;AACV;AAEA;IACE,QAAQ;AACV;AAEA;IACE,QAAQ;AACV;AAEA;IACE,8BAA8B;AAChC;AACA;IACE,aAAa;AACf;AACA;IACE,cAAc;IACd,aAAa;AACf;AAEA;IACE,cAAc;IACd,oBAAoB;AACtB;AAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACrB;AAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AAClB;AACA;IACE,eAAe;AACjB;AAEA;IACE,mBAAmB;AACrB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACnB;AAEA;IACE,QAAQ;IACR,WAAW;AACb;AAEA;IACE,mBAAmB;AACrB;AACF;AAEA;AACE;IACE,WAAW;IACX,SAAS;AACX;AAEA;IACE,cAAc;AAChB;AAEA;IACE,2BAA2B;AAC7B;AACF;AAEA;AACE;IACE,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,QAAQ;AACV;AACF;AAEA;AACE;IACE,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,UAAU;AACZ;AACF;AACA;EACE,uCAAuC;AACzC","sourcesContent":["<!--\r\nImportant:\r\nThis COmponent is used only for the Vue3 application\r\nAny modifications made should be done for Vue2 component also\r\nVue2File: wwwroot\\js\\components\\TextPermissionsOverlay\\TextPermissionsOverlay.vue\r\nDont forget to make the changes in both the files\r\nAny clarifications contact Leela\r\n-->\r\n<template>\r\n  <div v-if=\"showTextPermissions\" class=\"text-permissions-container\">\r\n    <div class=\"text-permissions-overlay\" />\r\n    <div class=\"text-permissions-modal overflow-auto\">\r\n      <div class=\"close-icon\">\r\n        <em class=\"primaryicon-times\" @click=\"skipTextPermissions()\" />\r\n      </div>\r\n      <div>\r\n        <div class=\"text-permissions-modal-content d-flex\">\r\n          <div\r\n            class=\"text-permissions-info d-flex justify-content-center align-items-center bgcolor-primary color-white\"\r\n          >\r\n            <div class=\"info-container\">\r\n              <em class=\"primaryicon-longarrow-right ft-20\" />\r\n              <div class=\"info-text\">\r\n                We will send you a text with important reminders about your vehicle.\r\n              </div>\r\n              <ul class=\"text-remainder-types\">\r\n                <li class=\"remainder-item service-updates\">\r\n                  <div class=\"icon-container\">\r\n                    <em class=\"color-primary primaryicon-service-car\" />\r\n                  </div>\r\n                  <span>{{ isMobile ? \"Service updates\" : \"Service reminders\" }}</span>\r\n                </li>\r\n                <li class=\"remainder-item loan-updates\">\r\n                  <div class=\"icon-container\">\r\n                    <em class=\"color-primary primaryicon-calender-inner-box\" />\r\n                  </div>\r\n                  <span>{{ isMobile ? \"Loan updates\" : \"Loan expiration reminders\" }}</span>\r\n                </li>\r\n                <li class=\"remainder-item recall-notifications\">\r\n                  <div class=\"icon-container\">\r\n                    <em class=\"color-primary primaryicon-service-notification\" />\r\n                  </div>\r\n                  <span>Recall notifications</span>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <form\r\n            novalidate\r\n            method=\"post\"\r\n            class=\"text-permissions-form d-flex justify-content-center\"\r\n            @submit.prevent=\"onSubmit()\"\r\n          >\r\n            <div class=\"form-container d-flex flex-column\">\r\n              <div class=\"form-content d-flex flex-column\">\r\n                <div class=\"form-header\">\r\n                  <h1 class=\"d-flex align-items-center flex-column\">\r\n                    <span class=\"user-name\">{{ userDetails.firstname }},</span>\r\n                    <span class=\"header-text\">would you like text updates about your vehicle?</span>\r\n                  </h1>\r\n                  <p v-if=\"!isMobile\" class=\"form-info\">\r\n                    We are updating our records regarding your {{ vehicleName }}. Please confirm\r\n                    your mobile number below.\r\n                  </p>\r\n                </div>\r\n                <!-- honey field -->\r\n                <input\r\n                  id=\"honeypot\"\r\n                  v-model=\"Tvmvalue\"\r\n                  type=\"text\"\r\n                  name=\"honeypotvalue\"\r\n                  class=\"honeypot\"\r\n                />\r\n                <!-- honey field -->\r\n                <div class=\"d-flex flex-column question\">\r\n                  <div class=\"radio-btn custom-radio-btn d-flex align-items-center\">\r\n                    <div class=\"d-flex align-items-center\">\r\n                      <input\r\n                        id=\"textPermissionsYes\"\r\n                        v-model=\"textPermission\"\r\n                        name=\"textPermission\"\r\n                        class=\"custom-radio-btn-input\"\r\n                        type=\"radio\"\r\n                        value=\"true\"\r\n                      />\r\n                    </div>\r\n                    <label for=\"textPermissionsYes\" class=\"custom-radio-btn-label d-flex\">\r\n                      Yes, text me with updates\r\n                    </label>\r\n                  </div>\r\n                </div>\r\n                <div class=\"d-flex flex-column number-container\">\r\n                  <label>Confirm your mobile number <span class=\"number-required\">*</span></label>\r\n                  <input\r\n                    v-model=\"mobileNumber\"\r\n                    class=\"number-input website-input-box\"\r\n                    :class=\"[{ error: mobileNumberError }]\"\r\n                    type=\"text\"\r\n                    placeholder=\"Enter mobile number\"\r\n                    @keypress=\"isNumberKey\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"form-footer d-flex justify-content-center\">\r\n                <input\r\n                  type=\"submit\"\r\n                  value=\"SUBMIT\"\r\n                  class=\"btn bgcolor-primary color-white submit-button btn-websites button-primary\"\r\n                />\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n<script type=\"text/javascript\" src=\"./TextPermissionsOverlay.js\"></script>\r\n\r\n<style scoped>\r\n.h-md-100 {\r\n  height: 100%;\r\n}\r\n\r\n.close-icon {\r\n  color: #d3d3d3;\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.text-permissions-overlay {\r\n  position: fixed;\r\n  z-index: 1034;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  top: 0px;\r\n  left: 0px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.text-permissions-modal {\r\n  position: fixed;\r\n  z-index: 1035;\r\n  left: 23vw;\r\n  top: 5vh;\r\n  width: 54vw;\r\n  max-height: 92vh;\r\n  overflow: auto;\r\n}\r\n\r\n.text-permissions-info {\r\n  flex-basis: 42%;\r\n}\r\n\r\n.info-container {\r\n  padding: 0 20%;\r\n}\r\n\r\n.text-permissions-form {\r\n  flex-basis: 58%;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.form-container {\r\n  padding-bottom: 36px;\r\n\r\n  margin: 56px 68px 74px 68px;\r\n  background-color: white;\r\n}\r\n\r\n.form-header {\r\n  text-align: center;\r\n}\r\n\r\n.radio-btn {\r\n  gap: 12px;\r\n}\r\n\r\n.radio-btn .custom-radio-btn-input {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: block;\r\n}\r\n\r\n.custom-radio-btn-input {\r\n  position: relative;\r\n  appearance: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-radio-btn-input::before {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 20px;\r\n  background-color: black;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  opacity: 0.3;\r\n}\r\n\r\n.custom-radio-btn-input::after {\r\n  content: \"\";\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: white;\r\n  border: 4px solid white;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n  left: 50%;\r\n  top: 50%;\r\n  z-index: 2;\r\n}\r\n\r\n.custom-radio-btn-input:checked::after {\r\n  background-color: black;\r\n}\r\n\r\n.radio-btn label {\r\n  margin-bottom: 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n.user-name {\r\n  font-size: 36px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.header-text {\r\n  font-size: 24px;\r\n  line-height: 30px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.form-info {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.question {\r\n  margin-bottom: 72px;\r\n  gap: 16px;\r\n}\r\n\r\n.number-required {\r\n  color: red;\r\n}\r\n\r\n.number-container {\r\n  margin-bottom: 76px;\r\n}\r\n\r\n.number-input {\r\n  outline: none;\r\n  border: unset;\r\n  border-bottom: 1px solid #e4e4e4;\r\n  padding-bottom: 16px;\r\n}\r\n\r\n.number-input-error {\r\n  color: red;\r\n  font-size: 14px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.text-remainder-types {\r\n  list-style: none;\r\n  padding: unset;\r\n  margin: unset;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.remainder-item {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.info-text {\r\n  font-size: 20px;\r\n  line-height: 30px;\r\n  margin-bottom: 32px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.icon-container {\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.form-content {\r\n  padding: 48px 40px 0px 46px;\r\n}\r\n\r\n.form-footer {\r\n  margin-top: auto;\r\n  gap: 16px;\r\n  padding-top: 32px;\r\n  border-top: 1px solid #e4e4e4;\r\n}\r\n\r\n.submit-button {\r\n  border-radius: 24px;\r\n  padding: 8px 32px;\r\n  font-weight: bold;\r\n}\r\n\r\n.skip-button {\r\n  background: unset;\r\n  color: #d3d3d3;\r\n  border-radius: 20px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .text-permissions-modal {\r\n    height: 90vh;\r\n    top: 2vh;\r\n    width: 90vw;\r\n    left: 5vw;\r\n  }\r\n\r\n  .info-container .primaryicon-longarrow-right {\r\n    display: none;\r\n  }\r\n\r\n  .recall-notifications {\r\n    order: 1;\r\n  }\r\n\r\n  .service-updates {\r\n    order: 2;\r\n  }\r\n\r\n  .loan-updates {\r\n    order: 3;\r\n  }\r\n\r\n  .text-permissions-modal-content {\r\n    flex-direction: column-reverse;\r\n  }\r\n  .form-container {\r\n    margin: unset;\r\n  }\r\n  .form-footer {\r\n    padding: unset;\r\n    border: unset;\r\n  }\r\n\r\n  .text-permissions-info {\r\n    padding: unset;\r\n    padding-bottom: 36px;\r\n  }\r\n\r\n  .info-container {\r\n    padding: unset;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .info-text {\r\n    font-size: 17px;\r\n    line-height: 32px;\r\n    text-align: center;\r\n    margin-bottom: 16px;\r\n    margin-top: 24px;\r\n  }\r\n  .remainder-item span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .question {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .user-name {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .form-content {\r\n    padding-top: 32px;\r\n  }\r\n\r\n  .header-text {\r\n    margin-bottom: 17px;\r\n    font-size: 18px;\r\n    line-height: 26px;\r\n  }\r\n\r\n  .close-icon {\r\n    top: 8px;\r\n    right: 12px;\r\n  }\r\n\r\n  .number-container {\r\n    margin-bottom: 32px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1199px) {\r\n  .text-permissions-modal {\r\n    width: 84vw;\r\n    left: 8vw;\r\n  }\r\n\r\n  .info-container {\r\n    padding: 0 10%;\r\n  }\r\n\r\n  .form-container {\r\n    margin: 56px 40px 74px 40px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1399px) {\r\n  .text-permissions-modal {\r\n    max-height: 90vh;\r\n    width: 54vw;\r\n    left: 23vw;\r\n    top: 2vh;\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .text-permissions-modal {\r\n    max-height: 82vh;\r\n    top: 5vh;\r\n    width: 54vw;\r\n    left: 23vw;\r\n  }\r\n}\r\n.error {\r\n  border-bottom: 1px solid red !important;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
